// @vendors
import { put, takeLatest, call } from 'redux-saga/effects';
import get from 'lodash/get';

// @Services
import { doLogin, checkLogin, getRoles, /*doLogout,*/ } from './auth.services';

// @Actions
import {
  REQUEST_FAILURE,
  REQUEST_FINISHED,
  REQUEST_STARTED,
} from '../app/app.actionTypes';
import {
  CHECK_AUTHENTICATION,
  LOGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  LOGOUT,
  LOGOUT_SUCCESS,
  SET_AUTHENTICATION,
  LOGIN_WAIT, CHECK_LOGIN
} from './auth.actionTypes';

// @Utils
import {
  buildErrorsObj,
  getAuthorizationToken,
    getSessionId,
  getUserLogged,
  signIn,
  signOut,
} from '../../utils/auth';

function* loginWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(doLogin, payload.data);

    if (get(response, 'data.status.errcode', null)) {
      yield put({
        type: LOGIN_FAILURE,
        payload: {
          authenticatedErrorMessage: get(response, 'data.status.errmsg', '')
        }
      });
    } else {
      const data = get(response, 'data.status.errmsg', '');

      yield put({
        type: LOGIN_WAIT,
        payload: {
          webToken: data
        }
      })
    }


    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: LOGIN_FAILURE
    });
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* checkLoginWorker({ payload }) {
  try {
    yield put({ type: REQUEST_STARTED });

    const response = yield call(checkLogin, payload.data);

    const errcode = get(response, 'data.status.errcode', null);
    const status = get(response, 'data.status.code', null);
    const data = get(response, 'data.result.0', null);

    switch (errcode) {
      case 30282:
        yield put({
          type: LOGIN_FAILURE,
          payload: {
            authenticatedErrorMessage: 'Se ha excedido el tiempo de verificación de identidad. Reintente.'
          }
        });
        break;
      case 30283:
        yield put({
          type: LOGIN_FAILURE,
          payload: {
            authenticatedErrorMessage: 'La geolocalización del Log In Web no es válida.'
          }
        });
        break;
      default:
        break;
    }

    if (status === 1) {
      signIn(data);

      const response = yield call(getRoles);

      console.log(response);

      const roles = get(response, 'data.result', []);

      const gate = roles.find(r => r.servicioHooliCod === 'HGATE');

      if (gate) {
        window.location = `https://gate-dev.hooli.la?session=${getSessionId()}&token=${getAuthorizationToken()}&merchantId=${gate.merchantId}`;

      } else {
        yield put({
          type: LOGIN_SUCCESS,
          payload: {
            isAuthenticated: true,
            userLogged: {
              usuarioApellidos: get(data, 'usuarioApellidos', ''),
              usuarioNombres: get(data, 'usuarioNombres', ''),
              usuarioId: get(data, 'usuarioId', ''),
              roles: response.result
            }
          }
        });

      }


    }


    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: LOGIN_FAILURE,
      payload: {
        authenticatedErrorMessage: 'Los servicios de hooli no estan disponibles'
      }
    });
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* checkAuthenticationWorker() {
  try {
    yield put({ type: REQUEST_STARTED });

    if (getAuthorizationToken()) {
      const data = getUserLogged();
      yield put({
        type: LOGIN_SUCCESS,
        payload: {
          userLogged: data,
          isAuthenticated: true
        }
      });
    } else {
      yield put({
        type: SET_AUTHENTICATION,
        payload: {
          userLogged: {},
          isAuthenticated: false
        }
      });
    }

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* logoutWorker() {
  try {
    yield put({ type: REQUEST_STARTED });

    // yield call(doLogout);

    signOut();

    yield put({ type: LOGOUT_SUCCESS });

    yield put({ type: REQUEST_FINISHED });
  } catch (err) {
    yield put({
      type: REQUEST_FAILURE,
      payload: buildErrorsObj(err)
    });
  }
}

function* requestWatcher() {
   yield takeLatest(LOGIN, loginWorker);
   yield takeLatest(CHECK_LOGIN, checkLoginWorker);
   yield takeLatest(CHECK_AUTHENTICATION, checkAuthenticationWorker);
   yield takeLatest(LOGOUT, logoutWorker);
}

export default { requestWatcher };



// WEBPACK FOOTER //
// ./src/state/auth/auth.sagas.js